import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import HealthAndFitness from './HealthAndFitness';

export default function Blog() {
  return (
    <>
        <Navbar />
        <HealthAndFitness />
        <Footer />
        <Copyright />
    </>
  )
}